<script>
import hooksMixin from '@/v-shop/mixins/hooks-mixin'

export default {
	lang: 'shop',
	mixins: [hooksMixin('ProductPage')],
	inject: ['hookContainer'],
	props: {
		sheetType: String,
	},
	data() {
		return {
			showPromotions: false,
		}
	},
	computed: {
		ProductPage() {
			return this.hookContainer()
		},
		product() {
			return this.ProductPage.product
		},
		reviewsConfig() {
			return this.ProductPage.reviewsConfig
		},
		customization() {
			return this.ProductPage.customization
		},
		validation() {
			return this.ProductPage.validation
		},
		hideStockAvailabilityMessage() {
			return this.ProductPage.hideStockAvailabilityMessage
		},
		colSizes() {
			return this.ProductPage.colSizes
		},
		hooksData() {
			return this.ProductPage.hooksData
		},
		marketplaceMode() {
			return process.env.VUE_APP_MARKETPLACE_MODE
		},
		selectedVariant() {
			return this.ProductPage.selectedVariant
		},
		btnText() {
			return this.ProductPage.btnText
		},
		discountsTagsTexts() {
			if (!this.ProductPage.discountsTagsTexts?.length) return
			return this.ProductPage.discountsTagsTexts.map(this.splitTagText)
		},
		hasLimitedTimeOffer() {
			return this.ProductPage.hasLimitedTimeOffer
		},
		productOffers() {
			return this.ProductPage.productOffers
		},
		financingTagHtml() {
			return this.ProductPage.financingTagHtml
		},
		selectedVariantId: {
			get() {
				return this.ProductPage.selectedVariantId
			},
			set(val) {
				this.$emit('update:selectedVariantId', val)
			},
		},
		currentPromos() {
			return (this.ProductPage.promos || []).filter((x) => {
				return x.matchedVariantsIds?.includes(this.selectedVariant.id)
			})
		},
		imgIndex: {
			get() {
				return this.ProductPage.imgIndex
			},
			set(val) {
				this.$emit('update:imgIndex', val)
			},
		},
		cRatingAvg: {
			get() {
				return this.ProductPage.product.ratingAvg
			},
			set(val) {
				this.$emit('update:ratingAvg', val)
			},
		},
		cImgIndex: {
			get() {
				return this.imgIndex
			},
			set(val) {
				this.$emit('update:imgIndex', val)
			},
		},
	},
	methods: {
		scrollToReviews() {
			this.$vuetify.goTo('#reviews-scroll-point', { duration: 500, offset: 0 })
		},
		splitTagText(tag) {
			let text = tag.split('$').map((s) => s.trim())
			let msg = text[0]
			let amount = text[1]
			return { msg, amount }
		},
	},
}
</script>

<template>
	<div class="pb-3">
		<hook zone="main-content">
			<v-row :class="sheetType == 'defaultInverted' && 'flex-row-reverse'">
				<v-col cols="12" :md="colSizes.left" class="no-mobile-px" :class="$b({ d: 'grey-border-right' })">
					<hook zone="images">
						<ProductImagesCarousel
							v-if="sheetType == 'default' || sheetType == 'defaultInverted' || $b.m"
							v-model="cImgIndex"
							:scale-down="false"
							:product="product"
							:invert="sheetType == 'defaultInverted'"
						/>
						<ProductImagesGrid
							v-else-if="sheetType == 'grid'"
							v-model="cImgIndex"
							:scale-down="false"
							:product="product"
						/>
					</hook>
				</v-col>
				<v-col cols="12" :md="colSizes.right" id="zoom-window-container">
					<div class="px-0 px-md-6" v-super-sticky="$b.m ? false : { topAsHeightOf: '.appbar' }">
						<v-row>
							<v-col cols="10">
								<h1 class="header font-weight-bold font-6 py-1">{{ product.name }}</h1>
								<!-- USER REVIEWS -->
								<hook
									zone="user-reviews"
									v-if="
										reviewsConfig &&
										reviewsConfig.enabled &&
										(reviewsConfig.permissions == 'free' ? true : product.ratingCount > 0)
									"
								>
									<div class="mb-2 user-reviews-btn d-flex align-center" @click="scrollToReviews">
										<v-rating
											dense
											half-increments
											v-model="cRatingAvg"
											:color="$vars.strongtext"
											background-color="#cececd"
											small
											readonly
										></v-rating>
										<p class="mb-0 ml-1 d-inline-block link--text">({{ product.ratingCount }})</p>
									</div>
								</hook>
								<!-- END USER VALORATIONS -->
								<hook zone="brand-sku">
									<ProductPage-BrandSkuEanSeller
										:product="product"
										:selected-variant="selectedVariant"
									/>
								</hook>
							</v-col>
							<v-col cols="2" class="text-right">
								<div
									class="wishlist-share w100 h100 d-flex flex-column align-center justify-center"
									:class="{ 'align-end': $b.t }"
								>
									<ProductWishlistToggler
										class="flex-grow mb-3"
										:productId="product.id"
										:heartWidth="25"
									/>
									<ShareProduct :productName="product.name" />
								</div>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="d-flex flex-wrap align-center icons-offer">
								<CollectionEventIcon
									multiple
									:product="product"
									class="event-icon"
									:limitAmount="$b.m ? 5 : null"
								/>
								<ProductPage-LimitedTimeOffer
									:product="product"
									:productOffers="productOffers"
									v-if="hasLimitedTimeOffer"
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<div style="position: relative">
									<VariantsSelector
										v-model="selectedVariantId"
										:product="product"
										class="pb-3"
										:show-select-input="true"
									/>
									<hook zone="price-layout">
										<PriceLayout
											:product="product"
											:prev-price="selectedVariant.pvPrice.prevPrice"
											:price="selectedVariant.pvPrice.price"
											:discount-pct="selectedVariant.pvPrice.discountPct"
											:unit-metric="product.packMetric ? product.unitMetric : null"
											:currency="selectedVariant.pvPrice.priceConfig.currency.sign"
											price-class="font-8"
										/>
									</hook>
									<div
										class="d-inline-block promotions link--text my-4"
										@click="showPromotions = true"
									>
										Mirá todas las promociones
									</div>
									<ProductPage-PaymentsModal
										v-model="showPromotions"
										:selectedVariantId="selectedVariant.id"
									/>
									<div
										v-for="(html, n) in financingTagHtml"
										:key="`financing-tag-${n}`"
										class="my-2 py-1 px-2 primary rounded"
										style="width: fit-content"
										v-html="html"
									></div>
									<div
										v-for="(item, i) of ProductPage.discountsTagsTexts"
										:key="`discount-tag-${i}`"
										class="my-2 py-1 px-2 secondary rounded"
										style="width: fit-content"
										v-html="item"
									></div>

									<ProductPage-Tags />

									<div class="py-2 font-1">
										<ProductStockAvailabilityMessage
											v-if="!hideStockAvailabilityMessage"
											:stock="selectedVariant.stock"
											:product="product"
											class="py-1"
										/>
										<StockReminderForm :product="product" :variant="selectedVariant" />
										<div class="d-flex align-center py-1" v-if="selectedVariant.type == 'digital'">
											<v-icon class="mr-2">mdi-cloud-download</v-icon>
											{{ 'Producto digital descargable' | lang }}
										</div>
									</div>
									<DpcHook :items="ProductPage.hooksData['hooks-product-actions-top']" />
									<ProductPage-Promos
										:product="product"
										:variant="selectedVariant"
										:customization="customization"
										:promos="currentPromos"
										@validation="ProductPage.setValidation($event)"
										class="py-3"
									/>
									<hook zone="actions">
										<ProductActions
											:product="product"
											:variant="selectedVariant"
											:customization="customization"
											:ctaText="btnText"
											@validation="ProductPage.setValidation($event)"
											class="py-3"
										/>
									</hook>
									<DpcHook :items="ProductPage.hooksData['hooks-product-actions']" />
									<div
										class="my-1 pt-2 mx-n3 px-3 mx-md-n9 px-md-9"
										style="border-top: 1px solid #eee"
									>
										<ProductPage-DeliveryCalc
											:currency="selectedVariant.pvPrice.priceConfig.currency.sign"
											:selectedVariantId="selectedVariantId"
										/>
									</div>
									<div>
										<ProductPage-AdditionalPaymentInfo :product="product" />
									</div>
									<div
										class="pa-4 grey lighten-4 rounded-lg"
										v-if="$srv('orderTotalGoalProgressConfig.showInProductPage')"
									>
										<OrderTotalGoalProgress use-image />
									</div>
								</div>
							</v-col>
						</v-row>
					</div>
				</v-col>
			</v-row>
		</hook>
	</div>
</template>

<style>
.shadow {
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
</style>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

#zoom-window-container {
	position: relative;
}

.sticky-right-col {
	position: sticky;
	bottom: 16px;
	align-self: flex-end;
}

.promotions {
	text-decoration: underline;

	&:hover {
		cursor: pointer;
	}
}

::v-deep iframe {
	max-width: 100%;
	widows: 500px;
	min-height: 250px;
}

.wishlist-share {
	max-height: 102px;
	max-width: 102px;
}

.icons-offer {
	padding-top: 0;
	padding-bottom: 0;
	gap: 6px;
}

.user-reviews-btn {
	width: max-content;
	cursor: pointer;
}
</style>
